export const defaultDoorPositioning = 'chessboard';
export const defaultTexture = 'vertical';
export const defaultTopProfile = '02';
export const defaultBottomProfile = '01';
export const defaultAluminiumColor = 'AS';
export const defaultMilling = 'frez_DSP';
export const defaultSealing = 'YA-113';
export const defaultAssemblyScrew = 'D50';
export const assemblingAdditionalMechanism = '10100217301';
export const hingedMiddleDoorMechanism = 'дотяг_Tutti';
export const defaultDoorLatchMechanism = 'дотяг_верх_OPK';
export const topDoorLatchMechanism = 'дотяг_верх_OPK';
export const bottomDoorLatchMechanism = 'дотяг_низ';
export const defaultMirrorType = 'mirror_4';
export const defaultMirrorUvPrintType = 'print_uv_mir';
export const defaultLacobelType = 'lakob_1015';
export const defaultLacobelUVPrintType = 'print_uv_mir';
export const defaultGlassType = 'glass_4';
export const defaultGlassPhotoPrintType = 'print_lathd';
export const defaultGlassUvPrintType = 'print_uv_gl';
export const defaultCustomChipboard = 'dsp-large';
export const defaultStrainer = 'TD017A стяж';
export const defaultLanguage = 'uk';
export const defaultRegion = 'Львов';
export const packagingOfGuidanceProfile = 'pak_n';
export const defaultPackageName = 'Розничная USD';
export const defaultBung = 'AS-108-1';

export const minSectionHeight = 0;
export const minSectionWidth = 0;

// Min & max values for non-default doors amount
export const minWidthFor4AssemblingDoors = 600;
export const maxWidthFor4AssemblingDoors = 3000;
export const minWidthForSingleOpeningDoor = 200;
export const maxWidthForSingleOpeningDoor = 600;
export const minWidthForTwoOpeningDoors = 400;
export const maxWidthForTwoOpeningDoors = 1200;

export const ADSSystemTypesList = [
  'extendable', 'opening', 'assembling', 'monorail', 'hinged', 'suspended', 'frame-facades',
];
